import { ActivatedRoute, Params, Router } from '@angular/router';

type ParsedQueryParamValue = string | string[];
type ParsedQueryParams = Record<string, ParsedQueryParamValue>;
type RouterCommands = Parameters<Router['navigate']>[0];

export function getRouteParam(route: ActivatedRoute, paramName: string): string | null {
  for (const segment of route.pathFromRoot) {
    const value = segment.snapshot.paramMap.get(paramName);
    if (value) {
      return value;
    }
  }
  return null;
}

export function getPathWithoutQueryParams(url: string): string {
  const [path] = url.split(/[?#]/);
  return path || url;
}

export function getQueryParamsFromUrl(url: string): Params | null {
  const queryString = getQueryStringFromUrl(url);
  if (!queryString) {
    return null;
  }

  const queryParams = new URLSearchParams(queryString);
  return Array.from(queryParams.entries()).reduce<ParsedQueryParams>((params, [key, value]) => {
    const existingValue = params[key];

    if (existingValue === undefined) {
      params[key] = value;
    } else if (Array.isArray(existingValue)) {
      params[key] = [...existingValue, value];
    } else {
      params[key] = [existingValue, value];
    }

    return params;
  }, {}) satisfies Params;
}

export function navigateWithOptionalQueryParams(
  router: Router,
  commands: RouterCommands,
  queryParams?: Params,
): Promise<boolean> {
  return queryParams ? router.navigate(commands, { queryParams }) : router.navigate(commands);
}

function getQueryStringFromUrl(url: string): string {
  const queryStartIndex = url.indexOf('?');
  if (queryStartIndex === -1) {
    return '';
  }

  const fragmentStartIndex = url.indexOf('#', queryStartIndex);
  return url.slice(queryStartIndex + 1, fragmentStartIndex === -1 ? undefined : fragmentStartIndex);
}
